
define('text!absolute/ui/layout.json',[],function () { return '{\r\n\r\n}';});

